import React, { memo } from 'react';
import { Tariff } from 'reactApp/types/Billing';
import { useYearSaving } from 'reactApp/ui/TariffSectionNew/hooks/useYearSaving';
import { getTariffProductsByPeriods, isYear2Period } from 'reactApp/utils/Period';

import styles from './DiscountLabel.css';

export const DiscountLabel = memo(({ tariff, discount }: { tariff?: Tariff; discount?: string | number }) => {
    const hasTwoYearProduct = tariff?.products.some((item) => isYear2Period(item.period));
    const { yearProduct, monthProduct } = getTariffProductsByPeriods(tariff?.products || [], false, hasTwoYearProduct);

    const [_, yearSavingDiscount] = useYearSaving({ yearProduct, monthProduct });

    return <div className={styles.root}>- {yearSavingDiscount || discount}%</div>;
});

DiscountLabel.displayName = 'DiscountLabel';
